import * as React from "react";
import { SVGProps } from "react";

const Loading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={64}
    height={64}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    className="uil-ring-alt"
    {...props}
  >
    <path fill="none" className="bk" d="M0 0h100v100H0z" />
    <circle
      cx={50}
      cy={50}
      r={40}
      stroke="#000"
      fill="none"
      strokeWidth={6}
      strokeLinecap="round"
    >
      <animate
        attributeName="stroke-dashoffset"
        dur="3s"
        repeatCount="indefinite"
        from={0}
        to={502}
      />
      <animate
        attributeName="stroke-dasharray"
        dur="3s"
        repeatCount="indefinite"
        values="238.45 12.550000000000011;1 250;238.45 12.550000000000011"
      />
    </circle>
  </svg>
);

export default Loading;
